import React from 'react';
import styled from 'styled-components';
import {
  FilterDatePickerComponent,
  IconFilter,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';

const StyledInputComponent = styled(FilterDatePickerComponent)`
  && {
    min-width: 16rem;
  }
`;

export default () => {
  return (
    <IconFilter
      autoFocus
      position="bottom right"
      name="createdOn"
      placement="bottom-end"
      as={StyledInputComponent}
      dateFormat="dd-MM-yyyy"
      hasClearButton={false}
      hasApplyButton={false}
    />
  );
};
